import { homApi } from '~/redux/apis/hom'

import { Coupon, StripePrice, StripeSubscription } from '../types/subscription.types'

export const subscriptionApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getStripePrice: builder.query<
      { priceDetails: StripePrice; couponDetails?: Coupon },
      { couponCode?: string; promotionId?: string; priceId?: string; currency?: string }
    >({
      query: (params) => ({
        url: '/v1/payments/geo-location-price',
        method: 'GET',
        params,
      }),
    }),
    getStripePrices: builder.query<
      any,
      { couponCode?: string; currency?: string; priceIds?: string[]; excludeDnb?: boolean }
    >({
      query: (params) => ({
        url: '/v1/payments/geo-location-prices',
        method: 'GET',
        params,
      }),
    }),
    getStripeProduct: builder.query<any, void>({
      query: () => ({
        url: '/v1/payments/stripe/products',
        method: 'GET',
      }),
    }),
    getStripeCurrentSubscriptionDetails: builder.query<
      // The next invoice arrives nested on the subscription as `upcomingInvoice`.
      { subscription: StripeSubscription },
      { subscriptionId?: string }
    >({
      query: (params) => ({
        url: `/v1/payments/stripe/user-subscription-details/${params.subscriptionId}`,
        method: 'GET',
        params,
      }),
    }),
  }),
})

export const {
  useGetStripePriceQuery,
  useGetStripePricesQuery,
  useGetStripeProductQuery,
  useGetStripeCurrentSubscriptionDetailsQuery,
  util: { getRunningQueriesThunk },
} = subscriptionApi

export const { useQueryState: useGetStripePriceQueryState } = subscriptionApi.endpoints.getStripePrice
export const { getStripeProduct, getStripePrice, getStripePrices } = subscriptionApi.endpoints
